const tinyColor = require('tinycolor2')

export default function generateStyleVariables(primaryColor, dangerColor) {
  let defaultColors = generateColorVariants('--color-primary', primaryColor)
  for (let color in defaultColors) {
    document.documentElement.style
      .setProperty(color, defaultColors[color])
  }
  document.documentElement.style
    .setProperty('--color-danger', dangerColor)
}

function getMiddle(array, i = 0) {
  if (i * 2 + 2 in array) return getMiddle(array, i + 1)
  else return array[i]
}

function getMostReadableValue(color) {
  let lighteness = 1
  let lightValue = ''
  let colorVariants = []
  let readability = 0
  while (readability < 10) {
    lighteness++
    lightValue = tinyColor(color).lighten(lighteness).toString()
    colorVariants.push(lightValue)
    readability = tinyColor.readability(color, lightValue)
    if (lightValue === '#ffffff' || lighteness === 70) {
      break
    }
  }
  return getMiddle(colorVariants)
}

function generateColorVariants(key, color) {
  let lightValue = getMostReadableValue(color)
  let darkValue = tinyColor(color).darken(20).toString()
  if (tinyColor.readability(color, darkValue) < 2) {
    darkValue = '#ffffff'
  }
  let { r, g, b } = tinyColor(color).toRgb()
  let rgbValue = `${r}, ${g}, ${b}`

  let lightKey = `${key}-lighter`
  let darkKey = `${key}-darker`
  let rgbKey = `${key}-rgb`

  return {
    [key]: color,
    [lightKey]: lightValue,
    [darkKey]: darkValue,
    [rgbKey]: rgbValue
  }
}
